(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('symptom', {
            parent: 'entity',
            url: '/symptom',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Symptoms'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/symptom/symptoms.html',
                    controller: 'SymptomController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('symptom-detail', {
            parent: 'entity',
            url: '/symptom/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Symptom'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/symptom/symptom-detail.html',
                    controller: 'SymptomDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Symptom', function($stateParams, Symptom) {
                    return Symptom.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'symptom',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('symptom-detail.edit', {
            parent: 'symptom-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('symptom.new', {
            parent: 'symptom',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('symptom');
                });
            }]
        })
        .state('symptom.edit', {
            parent: 'symptom',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('symptom.delete', {
            parent: 'symptom',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-delete-dialog.html',
                    controller: 'SymptomDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
